const template = {
    'controlpanel-container': require('./templates/controlpanel-container.hbs'),
    'controlpanel-create-client': require('./templates/controlpanel-create-client.hbs'),
    'controlpanel-create-profile': require('./templates/controlpanel-create-profile.hbs'),
    'controlpanel-create-user': require('./templates/controlpanel-create-user.hbs'),

    'dashboard-chart-container': require('./templates/dashboard-chart-container.hbs'),
    'dashboard-view': require('./templates/dashboard-view.hbs'),
    'dashboard-view-no-header': require('./templates/dashboard-view-no-header.hbs'),

    'databoard-view': require('./templates/databoard-view.hbs'),
    'databoard-view-no-header': require('./templates/databoard-view-no-header.hbs'),

    'dialog-additional-area': require('./templates/dialog-additional-area.hbs'),
    'dialog-confirmation': require('./templates/dialog-confirmation.hbs'),
    'dialog-datepicker': require('./templates/dialog-datepicker.hbs'),
    'dialog-error': require('./templates/dialog-error.hbs'),
    'dialog-login': require('./templates/dialog-login.hbs'),
    'dialog-select': require('./templates/dialog-select.hbs'),
    'dialog-selection': require('./templates/dialog-selection.hbs'),
    'dialog-text-style': require('./templates/dialog-text-style.hbs'),
    'dialog-tradearea': require('./templates/dialog-tradearea.hbs'),
    'dialog-snapshots': require('./templates/dialog-snapshots.hbs'),
    'dialog-upload-wizard': require('./templates/dialog-upload-wizard.hbs'),
    'dialog-service-area-style': require('./templates/dialog-service-area-style.hbs'),

    'filter-actions': require('./templates/filter-actions.hbs'),
    'filter-select': require('./templates/filter-select.hbs'),

    'infoboard-content': require('./templates/infoboard-content.hbs'),
    'infoboard-list-item': require('./templates/infoboard-list-item.hbs'),

    'map-layer-areas-label': require('./templates/map-layer-areas-label.hbs'),
    'map-layer-city-label': require('./templates/map-layer-city-label.hbs'),
    'map-layer-clients-popup': require('./templates/map-layer-clients-popup.hbs'),
    'map-layer-clients-cluster-popup': require('./templates/map-layer-clients-cluster-popup.hbs'),
    'map-layer-clients-cluster-popup-alt': require('./templates/map-layer-clients-cluster-popup-alt.hbs'),
    'map-layer-legend-point': require('./templates/map-layer-legend-point.hbs'),
    'map-layer-legend-polygon': require('./templates/map-layer-legend-polygon.hbs'),
    'map-layer-origin-destiny-popup': require('./templates/map-layer-origin-destiny-popup.hbs'),
    'map-layer-pgts-label': require('./templates/map-layer-pgts-label.hbs'),
    'map-layer-stores-cluster-popup': require('./templates/map-layer-stores-cluster-popup.hbs'),
    'map-layer-stores-in-mall-cluster-popup': require('./templates/map-layer-stores-in-mall-cluster-popup.hbs'),
    'map-layer-stores-popup': require('./templates/map-layer-stores-popup.hbs'),
    'map-layer-unapproved-stores-popup': require('./templates/map-layer-unapproved-stores-popup.hbs'),
    'map-layer-stores-sales': require('./templates/map-layer-stores-sales.hbs'),
    'map-layer-tvstations-label': require('./templates/map-layer-tvstations-label.hbs'),
    'map-layer-toll-label': require('./templates/map-layer-toll-label.hbs'),
    'map-layer-toll-popup': require('./templates/map-layer-toll-popup.hbs'),
    'map-layer-greenfield-popup': require('./templates/map-layer-greenfield-popup.hbs'),
    'map-layer-brownfield-popup': require('./templates/map-layer-brownfield-popup.hbs'),
    'map-layer-fuel-station-label': require('./templates/map-layer-fuel-station-label.hbs'),
    'map-layer-fuel-station-popup': require('./templates/map-layer-fuel-station-popup.hbs'),
    'map-layer-fuel-station-cluster-popup': require('./templates/map-layer-fuel-station-cluster-popup.hbs'),

    'map-layer-workshop-part-popup': require('./templates/map-layer-workshop-part-popup.hbs'),
    'map-layer-workshop-part-cluster-popup': require('./templates/map-layer-workshop-part-cluster-popup.hbs'),

    'map-layer-farm-machine-popup': require('./templates/map-layer-farm-machine-popup.hbs'),
    'map-layer-farm-machine-cluster-popup': require('./templates/map-layer-farm-machine-cluster-popup.hbs'),

    'navbar-reports-dropdown': require('./templates/navbar-reports-dropdown.hbs'),

    'points-edit-view': require('./templates/points-edit-view.hbs'),
    'stores-edit-view': require('./templates/stores-edit-view.hbs'),
    'stores-reporting-view': require('./templates/stores-reporting-view.hbs'),

    'search-input': require('./templates/search-input.hbs'),
    'search-result': require('./templates/search-result.hbs'),

    'shared-action-bar': require('./templates/shared-action-bar.hbs'),
    'shared-inline-filters': require('./templates/shared-inline-filters.hbs'),
    'shared-message': require('./templates/shared-message.hbs'),

    'sidebar-raster-maps': require('./templates/sidebar-raster-maps.hbs'),
    'sidebar-vector-cluster-heat-area': require('./templates/sidebar-vector-cluster-heat-area.hbs'),
    'sidebar-vector-cluster-heat': require('./templates/sidebar-vector-cluster-heat.hbs'),
    'sidebar-vector-layer': require('./templates/sidebar-vector-layer.hbs'),
    'sidebar-vector-layers': require('./templates/sidebar-vector-layers.hbs'),
    'sidebar-vector-layers-extended': require('./templates/sidebar-vector-layers-extended.hbs'),
    'sidebar-vector-layers-service-area': require('./templates/sidebar-vector-layers-service-area.hbs'),
    'sidebar-vector-layers-voronoi': require('./templates/sidebar-vector-layers-voronoi.hbs'),
    'sidebar-vector-points': require('./templates/sidebar-vector-points.hbs'),
    'sidebar-vector-range': require('./templates/sidebar-vector-range.hbs'),

    'stores-image': require('./templates/stores-image.hbs'),
    'stores-view': require('./templates/stores-view.hbs'),

    'summary-message': require('./templates/summary-message.hbs'),
    'summary-view': require('./templates/summary-view.hbs'),

    'map-layer-general-label': require('./templates/map-layer-general-label.hbs'),

    // After Sales
    'map-layer-stores-popup-after-sales': require('./templates/map-layer-stores-popup-after-sales.hbs'),
    'map-layer-stores-cluster-after-sales-popup': require('./templates/map-layer-stores-cluster-after-sales-popup.hbs'),
    'stores-view-after-sales': require('./templates/stores-view-after-sales.hbs'),
    'map-layer-dealership-popup-after-sales': require('./templates/map-layer-dealership-popup-after-sales.hbs'),
    'summary-view-after-sales': require('./templates/summary-view-after-sales.hbs'),
    'store-info-tab': require('./templates/store-info-tab.hbs'),
    'stores-influence-area': require('./templates/store-influence-area.hbs'),
};

const templates = (name, values) => {
    return template[name](values);
};

templates.get = (name) => {
    return (values) => {
        return template[name](values);
    };
};

export default templates;



// WEBPACK FOOTER //
// ./src/scripts/core/templates/index.js